/**
 * GitHub Codespaces Detection Utilities
 * 
 * This module provides reliable detection of GitHub Codespaces environment
 * for React applications. Used to configure API endpoints appropriately.
 * 
 * @see /front-end/package.json - proxy configuration
 * @see /front-end/src/helpers/utils/apiCalls.js - API endpoint configuration
 */
export const isRunningInCodespaces = () => {
  // Method 1: Check REACT_APP_CODESPACES (if properly set in devcontainer)
  if (process.env.REACT_APP_CODESPACES === 'true') {
    return true;
  }

  // Method 2: Check for Codespaces-specific hostname pattern (most reliable)
  if (typeof window !== 'undefined' && window.location.hostname.includes('app.github.dev')) {
    return true;
  }

  // Method 3: Check for other Codespaces hostname patterns
  if (typeof window !== 'undefined' && window.location.hostname.includes('github.dev')) {
    return true;
  }

  // Method 4: Check CODESPACES environment variable (this usually won't work in React)
  if (process.env.CODESPACES === 'true') {
    return true;
  }

  return false;
};

// Export individual check methods for debugging
export const getCodespacesDetectionInfo = () => {
  return {
    CODESPACES: process.env.CODESPACES,
    REACT_APP_CODESPACES: process.env.REACT_APP_CODESPACES,
    REACT_APP_CODESPACE_NAME: process.env.REACT_APP_CODESPACE_NAME,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'server-side',
    nodeEnv: process.env.NODE_ENV,
    isCodespaces: isRunningInCodespaces()
  };
};
